module.exports = __webpack_public_path__ + "static/media/free-scrap-removal-underwood.4282c285.png";